import { Spacing } from '@treneo/shared/themes';

import { styled } from '../styled';

import { Box } from './box';

export const StyledLogo = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: ${Spacing.small};
`;
